module.exports = __webpack_public_path__ + "static/img/setPurpose.d5b1428.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setPurpose.png
// module id = gY+x
// module chunks = 1